const empty = [];

const keys = value => (value ? Object.keys(value) : empty);

export default keys;
